window.sekstantAlarmDetailFormatter = function(value, row) {
    let html = "";
    if (row.cause) {
        html += '<div class="form-group">';
        html += "<label>" + __("Cause:") + "</label>";
        html += '<textarea class="form-control" rows="3">' + row.cause + "</textarea>";
        html += "</div>";
    }
    return html;
}
